module.exports = __webpack_public_path__ + "static/media/variant-b-video-replacement.ef363f3d.jpg";